<div class="card-border-radius grey-border p-3 p-xl-4">
  <div class="row account-card-row">
    <div class="col-12 col-md-4">
      <div class="row">
        <div class="col-12 d-flex gap-3 align-items-center justify-content-between justify-content-md-start">
          <div class="account-title">{{ accountName || instruction?.accountDetails?.type?.name }}</div>
          <app-status-pill [statusPill]="instruction.accountDetails?.status | accountStatusPill" />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col col-md-12 mt-3">
          <div class="account-employer">
            {{ instruction?.accountDetails?.employer }}
          </div>
          <div class="account-number mt-2">
            {{ instruction?.accountDetails?.accountId | leadingZero : 8 }}
          </div>
        </div>
        <div class="col-auto col-md-12 mt-3">
          <div class="account-balance">
            {{ instruction?.accountDetails?.totalBalance | currency }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-8">
      <div class="row investment-instructions-card-row">
        <div class="col-6 col-xl-3" *ngFor="let instruction of instruction?.investmentInstructions">
          <app-investment-instructions-card [instruction]="instruction" />
        </div>
      </div>
    </div>
  </div>
</div>
